<template>
  <div>
    <el-dialog
        :visible.sync="isOpen"
        :show-close="true"
        :before-close="handleClose"
        :top="'20px'"
        width="70%"
        class="create_dialog">
      <div class="body_dialog">
        <el-row type="flex" :gutter="20">
          <el-col :span="9">
            <div class="container_info_form">
              <h3 style="padding-bottom: 10px; border-bottom: 2px solid #78a5e7; font-family: system-ui; color: #000">
                Thông tin phiếu</h3>

              <div class="info_content">
                <div class="element_setting">
                  <span class="title_element">
                    Mã phiếu
                  </span>
                  <span>:</span>
                  <span class="content_element code_form">
                    {{ defaultDataForm.codeForm }}
                  </span>
                </div>

                <div class="element_setting">
                  <span class="title_element">
                    Người tạo
                  </span>

                  <span>:</span>

                  <span class="content_element">
                    {{ defaultDataForm.nameUserCreate }}
                  </span>
                </div>

                <div class="element_setting">
                  <span class="title_element">
                    Loại
                  </span>

                  <span>:</span>

                  <span class="content_element">
                    {{ formatAppTypeCreate(defaultDataForm.appTypeCreate) }}
                  </span>
                </div>

                <div class="element_setting">
                  <span class="title_element">
                    Thời gian áp dụng
                  </span>

                  <span>:</span>

                  <span v-if="defaultDataForm.fistDay && defaultDataForm.lastDay" class="content_element">
                    {{ defaultDataForm.fistDay | formatDate }} đến {{ defaultDataForm.lastDay | formatDate }}
                  </span>
                  <span v-else class="content_element">
                    Không
                  </span>
                </div>

                <div class="element_setting">
                  <span class="title_element">
                    Trả lời ẩn danh
                  </span>

                  <span>:</span>

                  <span class="content_element">
                    {{ defaultDataForm.anonymous ? "Có" : "Không" }}
                  </span>
                </div>

                <div class="element_setting">
                  <span class="title_element">
                    Sửa câu trả lời
                  </span>

                  <span>:</span>

                  <span class="content_element">
                    {{ defaultDataForm.fix ? "Có" : "Không" }}
                  </span>
                </div>

                <hr>

                <div class="element_setting">
                  <span class="title_element">
                    Lượt truy cập
                  </span>

                  <span>:</span>

                  <span class="content_element">
                    {{ defaultDataForm.visit }}
                  </span>
                </div>

                <div class="element_setting">
                  <span class="title_element">
                    Lượt xem
                  </span>

                  <span>:</span>

                  <span class="content_element">
                    {{ defaultDataForm.viewers }}
                  </span>
                </div>
              </div>
            </div>

            <div class="container_apply">
              <h3
                  style="
                  padding-bottom: 10px;
                  border-bottom: 2px solid rgb(120, 165, 231);
                  font-family: system-ui;
                  color: #000"
              >
                Thông tin người trả lời
              </h3>
              <div class="info_content">
                <div class="element_setting">
                  <span class="title_element">
                    Mã
                  </span>
                  <span>:</span>
                  <span class="content_element">
                    {{ typeUser === "kids" ? infoAnswerKid.code : infoAnswerTeacher.icode }}
                  </span>
                </div>

                <div class="element_setting">
                  <span class="title_element">
                    Họ và tên
                  </span>
                  <span>:</span>
                  <span class="content_element">
                    {{ typeUser === "kids" ? infoAnswerKid.name : infoAnswerTeacher.fullName }}
                  </span>
                </div>

                <div class="element_setting">
                  <span class="title_element">
                    Nhân sự / Học sinh
                  </span>
                  <span>:</span>
                  <span class="content_element">
                    {{ formatAppTypeAnswer(typeUser) }}
                  </span>
                </div>

                <div class="element_setting">
                  <span class="title_element">
                    SĐT
                  </span>
                  <span>:</span>
                  <span class="content_element">
                    {{ typeUser === "kids" ? infoAnswerKid.phone : infoAnswerTeacher.phone }}
                  </span>
                </div>
                <div class="element_setting">
                  <span class="title_element">
                    Ngày trả lời
                  </span>
                  <span>:</span>
                  <span class="content_element">
                    {{ typeUser === "kids" ? infoAnswerKid.dateSeenAnswer : infoAnswerTeacher.dateSeenAnswer }}
                  </span>
                </div>

              </div>
            </div>
          </el-col>

          <el-col :span="15">
            <div
                style="
                    border: 1px solid #bfbfbf;
                    border-radius: 10px;
                    padding: 20px 0;
                    height: 610px;
                    overflow: auto">
              <div style="display: flex; justify-content: center">
                <div class="survey_form">

                  <!--    Ảnh mở đầu phiếu    -->
                  <section class="wrap_image_form radius border">
                    <el-image class="main_image" :src="defaultDataForm.imgWeb"/>
                  </section>

                  <!--    Phần tiêu đề và mô tả phiếu    -->
                  <section class="header_survey_form radius border element_form">
                    <div class="header_survey_title">
                      <span>{{ defaultDataForm.title }}</span>
                    </div>

                    <div class="header_survey_description">
                      {{ defaultDataForm.description }}
                    </div>
                  </section>

                  <!--    Phần câu hỏi phiếu    -->
                  <section class="wrap_question" ref="wrapQuestion">
                    <div
                        class="radius border element_form"
                        v-for="(question, index) in defaultDataForm.questionAndAnswerResponseList"
                        :key="index"
                        :ref="`elementForm-${index}`"
                        @click="handleElementClick(index)"
                    >
                      <div class="element_body">
                        <el-row type="flex" :gutter="14">
                          <el-col :span="24">
                            <div class="element_question">
                              <div class="question_title">
                                {{ question.questionResponse.questionText }}
                                <span v-if="question.questionResponse.obligatory" style="color: red">*</span>
                              </div>

                              <!--   Với câu hỏi văn bản   -->
                              <div
                                  v-if="question.questionResponse.typeQuestion === 'Text'"
                                  style="padding-left: 16px"
                              >
                                <span style="white-space: pre-line">{{ question.answerResponse.answerText }}</span>
                              </div>

                              <!-- Với câu hỏi hộp kiểm (checkbox) -->
                              <div
                                  v-if="question.questionResponse.typeQuestion === 'CheckBox'"
                                  class="wrap_checkbox element_answer"
                              >
                                <el-checkbox
                                    :disabled="true"
                                    :checked="formatAnswer(question.answerResponse.answerText).includes(normalizeKey(item.value))"
                                    v-for="(item, indexOption) in question.questionResponse.valueQuestionArray"
                                    :label="item.value"
                                    :key="indexOption"
                                    class="container_checkbox"
                                >
                                  <div style="color: #000; ">
                                    {{ item.value }}
                                  </div>
                                </el-checkbox>
                              </div>

                              <!-- Với câu hỏi trắc nghiệm (radio) -->
                              <div
                                  v-if="question.questionResponse.typeQuestion === 'Radio'"
                                  class="wrap_checkbox element_answer"
                              >
                                <el-radio
                                    :disabled="true"
                                    v-for="(item, index) in question.questionResponse.valueQuestionArray"
                                    v-bind="formatAnswer(question.answerResponse.answerText).includes(normalizeKey(item.value)) ? {} : { label: item.value }"
                                    :key="index"
                                    class="container_checkbox"
                                >
                                  <div style="display: inline-block; color: #000;">
                                    {{ item.value }}
                                  </div>
                                </el-radio>
                              </div>

                              <!--   Với câu hỏi chọn điểm   -->
                              <div v-if="question.questionResponse.typeQuestion === 'Point'" class="element_answer">
                                <div style="display: flex; gap: 0 12px">
                                  <div
                                      v-for="(item, index) in 10"
                                      :key="index"
                                  >
                                    <span
                                        :class="parseInt(question.answerResponse.answerText) === index + 1 ? 'option_point choice_point' : 'option_point'"
                                    >
                                      {{ item }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <!--   Với câu hỏi đánh giá (Sao)   -->
                              <div v-if="question.questionResponse.typeQuestion === 'Star'">
                                <div style="display: flex; gap: 0 10px" class="element_answer">
                                  <span v-for="item in 5" :key="item"
                                        :class="parseInt(question.answerResponse.answerText) >= item ? 'icon_star choice_star' : 'icon_star disable_star'">
                                    <i class="el-icon-star-on"/>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="footer">
        <div style="padding: 10px 0">
          <el-button type="danger" @click="handleClose">
            <i class="el-icon-circle-close"/>
            Đóng
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import icon from "@/assets/icons";
import Vue from "vue";
import SurveyForm from "@/services/SurveyForm";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      defaultDataForm: {
        idForm: undefined,
        imgWeb: undefined,
        title: "",
        description: "",
        anonymous: "",
        nameUserCreate: "",
        appTypeCreate: "",
        visit: "",
        viewers: "",
        fistDay: "",
        lastDay: "",
        fix: "",
        answer: "",
        questionAndAnswerResponseList: [
          {
            questionResponse: {
              idQuestion: null,
              questionText: "",
              valueQuestion: "",
              typeQuestion: "Text",
              obligatory: false,
              valueQuestionArray: [
                {
                  value: "",
                }
              ],
            },
            answerResponse: {
              idAnswer: null,
              answerText: ""
            }
          },
        ],
        teacherAndKidsResponseApply: {
          teacherApplyList: [],
          kidsPlusApplyList: [],
        }
      },
      infoAnswerKid: {
        id: null,
        name: "",
        nickName: "",
        code: "",
        className: "",
        dateSeenAnswer: "",
        phone: "",
        answer: false
      },
      infoAnswerTeacher: {
        id: null,
        fullName: "",
        phone: "",
        dateSeenAnswer: "",
        answer: false,
        icode: ""
      },
      typeQuestionOptions: [
        {
          icon: icon.text,
          label: "Văn bản",
          value: "Text"
        },
        {
          icon: icon.checkbox,
          label: "Hộp kiểm",
          value: "CheckBox"
        },
        {
          icon: icon.radio,
          label: "Trắc nghiệm",
          value: "Radio"
        },
        {
          icon: icon.point,
          label: "Điểm",
          value: "Point"
        },
        {
          icon: icon.rating,
          label: "Đánh giá",
          value: "Star"
        }
      ],
      currentQuestionIndex: 0,
      listImageForm: [],
      isDialog: {
        dialogVisibleImage: false,
        dialogImageUrl: "",
      },
      classApply: {},
      typeUser: "",
      typeForm: "",
    }
  },

  methods: {
    setCurrentQuestionIndex(index) {
      this.currentQuestionIndex = index;
    },

    handleClose() {
      this.$emit("closeDialog");
    },

    resetData() {
      this.defaultDataForm = {
        idForm: undefined,
        imgWeb: undefined,
        title: "Tiêu đề phiếu khảo sát",
        description: "Mô tả phiếu khảo sát",
        questionResponseList: [
          {
            idQuestion: null,
            questionText: "",
            valueQuestion: "",
            typeQuestion: "Text",
            obligatory: false,
            valueQuestionArray: [
              {
                value: "",
              }
            ],
          }
        ]
      }
      this.currentQuestionIndex = 0;
      this.resetSurveyImageForm();
    },

    resetSurveyImageForm() {
      this.listImageForm = [];
      this.$refs.uploadImageSurveyForm.clearFiles();
    },

    handleElementClick(index) {
      this.setCurrentQuestionIndex(index);
      this.handleAnimationButtonAddByIndex(index);
    },

    handleAnimationButtonAddByIndex(index) {
      Vue.nextTick(() => {
        // Lấy phần tử `.element_form` được nhấn
        const elementForm = this.$refs[`elementForm-${index}`][0];
        const scrollTasks = this.$refs.scrollTasks;

        if (elementForm && scrollTasks) {
          const wrapQuestion = this.$refs.wrapQuestion;
          const wrapQuestionRect = wrapQuestion.getBoundingClientRect();
          const elementFormRect = elementForm.getBoundingClientRect();

          // Tính toán vị trí top tương đối của `.element_form` so với `.wrap_question`
          const topOffset = elementFormRect.top - wrapQuestionRect.top;

          // Cập nhật vị trí `top` của `.scroll_tasks`
          scrollTasks.style.top = `${topOffset}px`;
        }
      });
    },

    handlePictureCardPreview(file) {
      this.isDialog.dialogImageUrl = file.url;
      this.isDialog.dialogVisibleImage = true;
    },

    handleInitialData(idForm, typeUser, row) {
      this.typeUser = typeUser;

      if (typeUser === "kids") {
        this.infoAnswerKid = row;
      } else {
        this.infoAnswerTeacher = row;
      }
      this.fetchDataDetailAnswer(idForm, typeUser, row.id);
    },

    fetchDataDetailAnswer(idForm, type, id) {
      SurveyForm.getDataAnswerUser(idForm, type, id)
          .then((res) => {
            const data = res.data.data;

            data.questionAndAnswerResponseList.map((item) => {
              item.questionResponse["valueQuestionArray"] = [];
              if (item.questionResponse.typeQuestion === "CheckBox" || item.questionResponse.typeQuestion === "Radio") {
                item.questionResponse["valueQuestionArray"] = item.questionResponse.valueQuestion.split(";").map(item => ({value: item}));
              }
            });

            this.defaultDataForm = data;
          })
          .catch((err) => {
            console.log(err);
          })
    },

    formatAnswer(answerText) {
      if (answerText) {
        return answerText.split(";").map(item => this.normalizeKey(item));
      } else {
        return "";
      }
    },

    normalizeKey(key) {
      return key
          .normalize("NFD") // Chuẩn hóa Unicode
          .replace(/[\u0300-\u036f]/g, "") // Loại bỏ dấu
          .replace(/\s+/g, "_"); // Thay khoảng trắng bằng "_"
    },

    formatAppTypeCreate(type) {
      switch (type) {
        case "plus":
          return "Nhà trường";
        case "teacher":
          return "Lớp";
      }
    },

    formatAppTypeAnswer(type) {
      switch (type) {
        case "kids":
          return "Học sinh";
        case "teacher":
          return "Nhân sự";
      }
    },

    // isCheckedRadio(answers, value) {
    //   const normalizedValue = this.normalizeKey(value);
    //   return this.formatAnswer(answers).includes(normalizedValue);
    // }
  }
}
</script>

<style lang="scss" scoped>
.title_dialog {
  font-size: 26px;
  font-weight: 600;
  color: #fff;
}

.dialog_image {
  /deep/ .el-dialog__header {
    background-color: transparent;
  }
}

.body_dialog {
  margin-top: 18px;

  .survey_form {
  }
}

.wrap_image_form {
  height: 192px;
  position: relative;

  .image_form {
    width: 100%;
    height: 100%;

    /deep/ .el-image__inner {
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
}

.radius {
  border-radius: 10px;
  overflow: hidden;
}

.border {
  border: 1px solid #dadce0;
}

.element_form {
  margin-top: 10px;
  padding: 30px 34px 30px 34px;
  box-shadow: 0 0 8px 0 #DCDFE6;

  /deep/ input,
  /deep/ textarea {
    border-radius: initial;
    border: none;
    border-bottom: 1px solid #DCDFE6;
    padding: initial;
    color: #000;

    &:focus {
      border-bottom: 3px solid #78a5e7;
    }
  }

  /deep/ textarea::placeholder,
  /deep/ input::placeholder {
    color: #7b7b7b;
  }
}

.element_question {
  display: flex;
  flex-direction: column;

  .question_title {
    font-size: 14px;
    font-family: system-ui;
    color: #000;
    font-weight: 500;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #78a5e7;;
  }

  /deep/ textarea {
    border-radius: initial;
    border: none;
    border-bottom: 1px solid #DCDFE6;
    padding: 0 56px 0 14px;
  }
}

.header_survey_form {
  .header_survey_title {
    font-size: 24px;
    font-weight: 900;
    color: #000;
    font-family: system-ui;
    padding-bottom: 16px;
    border-bottom: 2px solid #78a5e7;

    /deep/ input::placeholder {
      font-size: 22px;
      font-weight: 500;
    }
  }

  .header_survey_description {
    font-family: system-ui;
    font-size: 14px;
    white-space: pre-line;
  }
}

.element_footer {
  padding: 30px 0 0 0;
  border-top: 1px solid #dadce0;
  display: flex;
  justify-content: end;
  gap: 0 34px;
  align-items: center;
  font-size: 18px;
}

.wrap_require {
  display: flex;
  align-items: center;
  gap: 0 18px;
  padding-left: 32px;
  border-left: 1px solid #dadce0;

  .label_require {
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }
}

.wrap_checkbox {

}

.container_checkbox {
  margin-bottom: 10px;
}

.checkbox_options {
  /deep/ input {
    width: 350px;
  }
}

.option_point {
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  border: 2px solid #b4b4b4;
  border-radius: 6px;
  color: #4e4e4e;
  font-weight: 600;
  background-color: #d6d6d6;
  cursor: not-allowed;
}

.icon_star {
  font-size: 34px;
  cursor: not-allowed;
}

.wrap_button_tasks {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 14px;
}

.wrap_question {
  position: relative;

  .scroll_tasks {
    position: absolute;
    right: -61px;
    top: 0;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    width: 50px;
    min-height: 28px;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
    gap: 10px 0;
    box-shadow: 0 0 8px 0 #DCDFE6;
    border: 1px solid #dadce0;
    transition: top 0.3s ease-in;

    .btn_scroll_tasks {
      font-size: 24px;
      cursor: pointer;
    }
  }
}

.upload_image_form {
  position: absolute;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  /deep/ .el-upload {
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 1px dashed #6f6f6f;
    z-index: 1;
    background-color: transparent;

    i {
      font-size: 20px;
    }
  }

  /deep/ .el-upload-list__item {
    margin: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  .container_image {
    height: 100%;
    width: 100%;

    img {
      object-fit: cover;
      object-position: center;
    }
  }
}

.dialog-footer {
  width: 50%;
}

.main_image {
  width: 100%;
  height: 100%;

  /deep/ .el-image__inner {
    object-fit: cover;
    object-position: center;
  }
}

.container_checkbox {
  display: block;
  margin-bottom: 16px;
}

.element_answer {
  padding-left: 16px;
}

.container_apply,
.container_info_form {
  border: 2px solid #78a5e7;
  padding: 10px 20px;
  border-radius: 10px;
}

.container_apply {
  margin-top: 10px;
}

.element_setting {
  margin-bottom: 6px;
  font-size: 16px;

  .title_element {
    min-width: 140px;
    display: inline-block;
  }

  .content_element {
    display: inline-block;
    margin-left: 8px;
  }

  .code_form {
    text-transform: uppercase;
  }
}

.element_list {
  border: 1px solid #a9a9a9;
  padding: 6px;
  border-radius: 6px;
}

.header_list {
  text-align: center;
  padding-bottom: 10px;
  padding-top: 4px;
  border-bottom: 1px solid #a9a9a9;
  margin-bottom: 10px;
  font-family: system-ui;
  color: #000;
  font-weight: 500;
}

.wrap_list {
  height: 200px;
  overflow: auto;
}

.element_apply {
  display: flex;
  gap: 0 2px;
  margin-bottom: 4px;
}

.list_icon {
  font-size: 12px;
  color: #67C23A;
}

.list_content {
  font-size: 12px;
  color: #000;
}

.survey_form {
  width: 80%;
}

.choice_star {
  color: #e8e810;
}

.disable_star {
  color: #7b7b7b;
}

.choice_point {
  background-color: #409eff;
  border: 2px solid #409eff;
  color: #fff;
}
</style>